export default __webpack_public_path__ + "static/media/bogdan-burcea.43720fe8.png";